import { useContext } from "react"
import classNames from "classnames"

import { ValueView } from "web/components"

import { DataTableContext } from "./DataTable"

const CELL_CLASSES =
  "datatable-data-cell border-neutral-9 max-w-full flex focus:bg-primary-10 px-2 py-1 font-bold text-sm bg-primary-9"

export default function TableSummary({ grandTotals, isStickySummary = false }) {
  const { columns, canSelectRow, isCompact, hasFrozenColumns, showRowNumbers } =
    useContext(DataTableContext)

  function getTotal(column) {
    if (!column.dataKey || !grandTotals) return null

    return grandTotals.find((total) => total.key === column.dataKey)
  }

  const sharedCellClasses = classNames(CELL_CLASSES, {
    "h-9": isCompact,
    "h-10": !isCompact,
    "text-primary-3": isStickySummary,
  })

  const ordinalClasses = classNames(sharedCellClasses, {
    "sticky left-0": hasFrozenColumns,
  })

  const rowSelectorClasses = classNames(sharedCellClasses, {
    sticky: hasFrozenColumns,
    "left-0": hasFrozenColumns && !showRowNumbers,
    "left-[30px]": hasFrozenColumns && showRowNumbers,
  })

  return (
    <div data-testid="datatable-table-summary" className="contents p-2">
      {showRowNumbers && (
        <div className={ordinalClasses} style={{ width: "30px" }} />
      )}
      {canSelectRow && (
        <div className={rowSelectorClasses} style={{ width: "30px" }} />
      )}
      {columns.map((column, index) => {
        const total = getTotal(column)

        const cellClasses = classNames(sharedCellClasses, {
          sticky: column.freeze,
          "border-r border-r-primary-8": column.isLastFrozenColumn,
        })

        const cellStyle = { ...column.style, left: column.leftPosition }

        return (
          <div className={cellClasses} style={cellStyle} key={index}>
            {!!total && (
              <ValueView
                value={total}
                fieldPresentation={column.presentation}
                percentValue={total.percent_value}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
